console.log('findation-page.js loaded');

console.log('location')
console.log(window.location.href)


let pageUrl = window.location.href



let productUrl = '';
let productTitle = '';
let step = 1;

if(pageUrl?.includes('/products/')) {

  if(pageUrl?.includes('-set') && document.querySelector('.bundle-component')) {

    const bundleContainer = document.querySelector('.product-popup-modal__opener').closest(".bundle-component")

    productUrl = '/products/'+bundleContainer?.getAttribute('data-bundle-component-handle')?.replace('essential-liquid-','');
    console.log(productUrl)
    productTitle = bundleContainer?.getAttribute('data-product-title').replace('*','');

  } else {
    productUrl = pageUrl.replace('https://jouercosmetics.com','');
    productTitle = document.querySelector('.product__info-wrapper .product__title h1').textContent;
  }


  step = 2;

  var app = new Vue({
    el: '#quiz',
    data: {
      key: 'e845d14e6843b130405ce5c26b572fdcc6d365ebef7e37fa62d233821d3c',
      message: 'Hello Vue!',
      step: step,
      productUrl: productUrl,
      productTitle: productTitle,
      embedId: '',
      brands: [],
      brandId: '',
      products: [],
      productId: '',
      shades: [],
      shadeIds: [],
      result: '',
      recommended_shade: null,
      resultMessage: null,
      resultP: null,
      resultV: null,
      resultDefaultP: null,
      resultDefaultV: null,
      isPdp: true
    },
    mounted:function(){
      this.setProductInfo(productUrl, productTitle);
    },
    methods: {
      setProductInfo(url, title) {
        this.reset();
        this.productUrl = url;
        this.productTitle = title;
        this.step = 2;
        this.setEmbedId();
        this.getBrands();
  
      },
      setProductDefaultInfo(url, title, img, price, id) {
        this.reset();
        this.resultDefaultP = true;
        this.productDefUrl = url;
        this.productDefTitle = title;
        this.productDefImg = img;
        this.productDefPrice = price;
        this.productDefId = id;
      },
      setEmbedId() {
        const embedData = {
          product_url: this.productUrl,
          api_key: this.key
        };
  
        fetch('https://findation.com/api/embed', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(embedData),
        })
          .then(response => response.json())
          .then(data => {
            this.embedId = data.embed_id
          })
          .catch((error) => {
            console.error('Error:', error);
          });
  
      },
      getBrands() {
        fetch(`https://findation.com/api/brands?api_key=${this.key}`)
          .then(response => response.json())
          .then(data => {
            this.brands = data;
          });
      },
      onChangeSetBrandId(e) {
        this.brandId = e.target.value
        this.getProducts();
        this.shadeIds = [];
        document.getElementById('product').value = "";
        document.getElementById('shade').value = "";
      },
      getProducts() {
        fetch(`https://findation.com/api/products?api_key=${this.key}&brand_id=${this.brandId}`)
          .then(response => response.json())
          .then(data => {
            this.products = data;
          });
      },
  
      onChangeSetProductId(e) {
        this.productId = e.target.value
        this.getShades();
        this.shadeIds = [];
        document.getElementById('shade').value = "";
      },
  
      getShades() {
        fetch(`https://findation.com/api/shades?api_key=${this.key}&product_id=${this.productId}`)
          .then(response => response.json())
          .then(data => {
            this.shades = data;
          });
      },
      onChangeAddShadeId(e) {
        this.shadeIds = [e.target.value];
      },
      search() {
        const data = {
          embed_id: this.embedId,
          api_key: this.key,
          shade_ids: this.shadeIds,
          product_url: this.productUrl
        };
        fetch('https://findation.com/api/search', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
          .then(response => response.json())
          .then(data => {
            this.result = data;
            this.step = 3;
            if (data.hasOwnProperty('recommended_shade')) {
              this.recommended_shade = data.recommended_shade;
              this.resultP = window.findationProducts.find(p => p.url == this.productUrl);
              this.resultV = this.resultP.variants.find(v => v.title == this.recommended_shade);
              this.resultShade = data.recommended_shade;
            } else if (data.hasOwnProperty('message')) {
              this.resultMessage = data.message;

              let productFind = {}
              
              for(let obj of window.findationProducts) {
                if(obj.url == this.productUrl) {
                  productFind = obj;
                }
              }

              if(productFind?.def_product) {
                for(let item of productFind.def_product.def_variants) {
                  if(item.id == productFind.def_product.def_variant) {
                    this.resultDefaultV = item;
                  }
                }
  
                this.resultDefaultP = productFind.def_product
              }

            }
          })
          .catch((error) => {
            console.error('Error:', error);
          });
  
      },
      isShowBack () {
        if((this.step == 2 && !this.isPdp) || this.step == 3) return true 
      },
      back() {
        this.step--;
      },
      addToCart(vid) {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
  
        const formData = new FormData();
        formData.append('id', vid);
        formData.append('quantity', 1);
        
        if (cart) {
          formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
  
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status === 422) {
              if (cart) alert(response.description);
              return;
            }
            cart.renderContents(response);
          }).catch((error) => {
            console.error('Error:', error);
          }).finally(() => {
            if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          });
      },
      reset() {
        this.embedId = '';
        this.brands = [];
        this.brandId = '';
        this.products = [];
        this.productId = '';
        this.shades = [];
        this.shadeIds = [];
        this.result = '';
        this.recommended_shade = null;
        this.resultMessage = null;
        this.resultP = null;
        this.resultV = null;
        this.resultDefaultP = null;
        this.resultDefaultV = null;
  
        document.getElementById('brand').value = "";
        document.getElementById('product').value = "";
        document.getElementById('shade').value = "";
      }
    }
  })

} else {
  var app = new Vue({
    el: '#quiz',
    data: {
      key: 'e845d14e6843b130405ce5c26b572fdcc6d365ebef7e37fa62d233821d3c',
      message: 'Hello Vue!',
      step: step,
      productUrl: productUrl,
      productTitle: productTitle,
      embedId: '',
      brands: [],
      brandId: '',
      products: [],
      productId: '',
      shades: [],
      shadeIds: [],
      result: '',
      recommended_shade: null,
      resultMessage: null,
      resultP: null,
      resultV: null,
      resultDefaultP: null,
      resultDefaultV: null,
      isPdp: false
    },
    methods: {
      setProductInfo(url, title) {
        this.reset();
        this.productUrl = url;
        this.productTitle = title;
        this.step = 2;
        this.setEmbedId();
        this.getBrands();
  
      },
      setProductDefaultInfo(url, title, img, price, id) {
        this.reset();
        this.resultDefaultP = true;
        this.productDefUrl = url;
        this.productDefTitle = title;
        this.productDefImg = img;
        this.productDefPrice = price;
        this.productDefId = id;
      },
      isShowBack () {
        if((this.step == 2 && !this.isPdp) || this.step == 3) return true
      },
      setEmbedId() {
        const embedData = {
          product_url: this.productUrl,
          api_key: this.key
        };
  
        fetch('https://findation.com/api/embed', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(embedData),
        })
          .then(response => response.json())
          .then(data => {
            this.embedId = data.embed_id
          })
          .catch((error) => {
            console.error('Error:', error);
          });
  
      },
      getBrands() {
        fetch(`https://findation.com/api/brands?api_key=${this.key}`)
          .then(response => response.json())
          .then(data => {
            this.brands = data;
          });
      },
      onChangeSetBrandId(e) {
        this.brandId = e.target.value
        this.getProducts();
        this.shadeIds = [];
        document.getElementById('product').value = "";
        document.getElementById('shade').value = "";
      },
      getProducts() {
        fetch(`https://findation.com/api/products?api_key=${this.key}&brand_id=${this.brandId}`)
          .then(response => response.json())
          .then(data => {
            this.products = data;
          });
      },
  
      onChangeSetProductId(e) {
        this.productId = e.target.value
        this.getShades();
        this.shadeIds = [];
        document.getElementById('shade').value = "";
      },
  
      getShades() {
        fetch(`https://findation.com/api/shades?api_key=${this.key}&product_id=${this.productId}`)
          .then(response => response.json())
          .then(data => {
            this.shades = data;
          });
      },
      onChangeAddShadeId(e) {
        this.shadeIds = [e.target.value];
      },
      search() {
        const data = {
          embed_id: this.embedId,
          api_key: this.key,
          shade_ids: this.shadeIds,
          product_url: this.productUrl
        };
        fetch('https://findation.com/api/search', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
          .then(response => response.json())
          .then(data => {
            this.result = data;
            this.step = 3;
            if (data.hasOwnProperty('recommended_shade')) {
              this.recommended_shade = data.recommended_shade;
              this.resultP = window.findationProducts.find(p => p.url == this.productUrl);
              this.resultV = this.resultP.variants.find(v => v.title == this.recommended_shade);
              this.resultShade = data.recommended_shade;
            } else if (data.hasOwnProperty('message')) {
              this.resultMessage = data.message;

              let productFind = {}
              
              for(let obj of window.findationProducts) {
                if(obj.url == this.productUrl) {
                  productFind = obj;
                }
              }

              if(productFind?.def_product) {
                for(let item of productFind.def_product.def_variants) {
                  if(item.id == productFind.def_product.def_variant) {
                    this.resultDefaultV = item;
                  }
                }
  
                this.resultDefaultP = productFind.def_product
              }


            }
          })
          .catch((error) => {
            console.error('Error:', error);
          });
  
      },
      back() {
        this.step--;
      },
      addToCart(vid) {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
  
        const formData = new FormData();
        formData.append('id', vid);
        formData.append('quantity', 1);
        
        if (cart) {
          formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
  
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status === 422) {
              if (cart) alert(response.description);
              return;
            }
            cart.renderContents(response);
          }).catch((error) => {
            console.error('Error:', error);
          }).finally(() => {
            if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          });
      },
      reset() {
        this.embedId = '';
        this.brands = [];
        this.brandId = '';
        this.products = [];
        this.productId = '';
        this.shades = [];
        this.shadeIds = [];
        this.result = '';
        this.recommended_shade = null;
        this.resultMessage = null;
        this.resultP = null;
        this.resultV = null;
        this.resultDefaultP = null;
        this.resultDefaultV = null;
  
        document.getElementById('brand').value = "";
        document.getElementById('product').value = "";
        document.getElementById('shade').value = "";
      }
    }
  })
}




